"use strict";

var _Object$defineProperty = require("@babel/runtime-corejs2/core-js/object/define-property");
var _interopRequireDefault = require("@babel/runtime-corejs2/helpers/interopRequireDefault");
_Object$defineProperty(exports, "__esModule", {
  value: true
});
exports.default = void 0;
var _assign = _interopRequireDefault(require("@babel/runtime-corejs2/core-js/object/assign"));
var typeTemplate = 'ليس ${label} من نوع ${type} صالحًا';
var common = {
  reset: 'إعادة ضبط',
  cancel: 'يلغي',
  confirm: 'بالتأكيد',
  noData: 'لايوجد بيانات',
  noSearchResult: 'لا توجد نتائج بحث حتى الآن'
};
var _default = exports.default = {
  AutoComplete: {
    placeholder: 'من فضلك أدخل',
    noData: 'نتائج البحث عن'
  },
  FileInput: {
    placeholder: 'الرجاء اختيار الملف',
    remove: 'إزالة',
    choice: 'مختار'
  },
  Upload: {
    defaultError: 'فشل تحميل'
  },
  ImageUpload: {
    upload: 'انقر فوق تحميل',
    uploadAgain: 'انقر فوق إعادة تحميل'
  },
  Loading: {
    text: 'تحميل'
  },
  Modal: {
    openText: 'أكّد',
    closeText: 'ألغى'
  },
  Select: {
    placeholder: 'الرجاء اختيار',
    noData: 'نتائج البحث عن',
    noChoice: 'خيار مؤقت',
    etc: 'الخ .',
    indivual: 'فردي'
  },
  Cascader: {
    noData: 'لايوجد بيانات',
    noMatch: 'لا توجد بيانات مطابقة'
  },
  Mark: {
    texts: ['فقير جدا', 'خيبة الامل', 'عمومًا', 'رضا', 'مفاجأة']
  },
  DatePicker: {
    monthText: ['يناير', 'فبراير', 'مارس', 'أبريل', 'مايو', 'يونيو', 'يوليو', 'أغسطس', 'سبتمبر', 'أكتوبر', 'نوفمبر', 'ديسمبر'],
    quarter: ['Q1', 'Q2', 'Q3', 'Q4'],
    halfYear: ['H1', 'H2'],
    daysText: ['أحد', 'اثنين', 'ثلثاء', 'أربعاء', 'خميس', 'جمعة', 'سبت'],
    placeholder: 'الرجاء تحديد الوقت',
    selectStartPlaceholder: 'وقت البدء',
    selectEndPlaceholder: 'وقت النهاية',
    selectMonthText: 'الرجاء اختيار الشهر',
    selectYearText: 'الرجاء تحديد السنة',
    week: 'أسابيع',
    dayjsLocal: 'ar'
  },
  ImageView: {
    zoomIn: 'تكبير',
    zoomOut: 'تصغير',
    prev: 'السابق',
    next: 'التالي',
    rotateLeft: 'استدارة',
    reset: 'تخفيض',
    close: 'إنهاء',
    noData: 'لا توجد بيانات الصورة حتى الآن'
  },
  Pagination: {
    itemsPerPage: 'المقالة / الصفحة',
    jumpTo: 'إلى الثالث',
    jump: 'القفز',
    page: 'صفحة'
  },
  Table: {
    filterSearchPlaceholder: 'مرشحات البحث',
    filterReset: 'إعادة ضبط',
    filterConfirm: 'بالتأكيد',
    filterEmptyText: 'لا المرشحات',
    filterCheckall: 'اختر الكل',
    filterCheckNotall: 'إلغاء تحديد الكل',
    noData: 'لايوجد بيانات',
    triggerDesc: 'انقر للطلب التنازلي',
    triggerAsc: 'انقر لطلب تصاعدي',
    cancelSort: 'غير فرز',
    columnSet: 'إعدادات العمود',
    columnShow: 'عرض العمود',
    columnReset: 'إعادة ضبط',
    fixedColumn: 'تم إصلاح هذا العمود',
    fixedLeft: 'اليسار الثابت',
    fixedRight: 'حق ثابت',
    fixedCancel: 'إزالة التثبيت',
    fixedForbid: 'عمود ثابت غير قابل للتشغيل'
  },
  MultiCascader: {
    placeholder: 'اختر من فضلك',
    checkAll: 'الجميع',
    searchPlaceholder: 'يبحث',
    noResultsText: 'لا توجد نتائج مطابقة حتى الآن',
    checkAllButtonText: 'الجميع',
    noData: 'لايوجد بيانات'
  },
  Form: {
    optional: 'اختياري'
  },
  FormPro: {
    optional: 'اختياري',
    defaultValidateMessages: {
      default: 'خطأ في حقل الإدخال ${label}',
      required: 'يرجى إدخال ${label}',
      enum: '${label} يجب أن يكون واحدا من [${enum}]',
      whitespace: '${label} لا يمكن أن يكون حرفًا فارغًا',
      date: {
        format: '${label} تنسيق التاريخ غير صحيح',
        parse: '${label} لا يمكن تحويلها إلى تاريخ',
        invalid: 'تاريخ ${label} غير صحيح'
      },
      types: {
        string: typeTemplate,
        method: typeTemplate,
        array: typeTemplate,
        object: typeTemplate,
        number: typeTemplate,
        date: typeTemplate,
        boolean: typeTemplate,
        integer: typeTemplate,
        float: typeTemplate,
        regexp: typeTemplate,
        email: typeTemplate,
        url: typeTemplate,
        hex: typeTemplate
      },
      string: {
        len: 'يجب ${label} ان يكون ${len} أحرف',
        min: '${label} على الأقل ${min} أحرف',
        max: '${label} يصل إلى ${max} أحرف',
        range: 'يجب ${label} ان يكون مابين ${min}-${max} أحرف'
      },
      number: {
        len: '${len} ان يساوي ${label} يجب',
        min: '${min} الأدنى هو ${label} حد',
        max: '${max} الأقصى هو ${label} حد',
        range: '${max}-${min} ان يكون مابين ${label} يجب'
      },
      array: {
        len: 'يجب أن يكون ${label} طوله ${len}',
        min: 'يجب أن يكون ${label} طوله الأدنى ${min}',
        max: 'يجب أن يكون ${label} طوله الأقصى ${max}',
        range: 'يجب أن يكون ${label} طوله مابين ${min}-${max}'
      },
      pattern: {
        mismatch: 'لا يتطابق ${label} مع ${pattern}'
      }
    }
  },
  ImageEdit: {
    reset: 'إعادة ضبط',
    cancel: 'يلغي',
    confirm: 'بالتأكيد',
    replace: 'يستبدل',
    imageUpload: 'تحميل الصور',
    picturePreview: 'معاينة الصورة',
    imgClearVisible: ' يرجى التأكد من أن الصورة واضحة للعيان ※',
    imgScale: 'المحاصيل بشكل متناسب',
    zoomIn: 'تكبير',
    zoomOut: 'تصغير',
    rotateLeft: 'استدارة',
    cropSize: ':حجم المحاصيل الحالي'
  },
  Empty: {
    text: common.noData
  },
  LineFold: {
    collapse: 'يغلق',
    expand: 'يوسع'
  },
  OrganizationPicker: (0, _assign.default)((0, _assign.default)({}, common), {
    prompt: 'تَلمِيح',
    fail: 'فشل الحصول عليها',
    chosen: 'لقد اخترت',
    items: 'غرض',
    click: 'اضغط للعرض',
    org: 'الهيكل التنظيمي',
    chose: 'اختر الهيكل التنظيمي',
    search: 'بحث في الهيكل التنظيمي',
    pleaseChose: 'اختر من فضلك',
    searchContent: 'محتوى البحث',
    loading: 'تحميل',
    chosenItems: 'المحدد',
    empty: 'مسح التحديد',
    city: 'مدينة',
    cityGroup: 'مجموعة المدينة'
  }),
  Evaluation: {
    title: 'هل الميزات المذكورة أعلاه مفيدة لك؟？',
    likeDesc: 'عظيم، شجعني',
    dislikeDesc: 'ليس جيدًا، استمر في التحسين',
    feedbackDesc: 'إعطاء بعض النصائح'
  },
  MultiTableSelector: (0, _assign.default)((0, _assign.default)({}, common), {
    rightText: 'البيانات المختارة',
    labelText: 'تفضل',
    search: 'استعلام'
  }),
  MultiTabSelector: (0, _assign.default)((0, _assign.default)({}, common), {
    maxSelected: 'الحد الأقصى للاختيار من بينها',
    ge: 'فردي',
    choose: 'المحدد',
    empty: 'مسح المحدد',
    chooseAll: 'اختر الكل',
    labelText: 'تفضل',
    confirmEmpty: 'موافق للمسح'
  }),
  CountDown: {
    "confirm": "يتأكد",
    "second": "ثانية"
  },
  DateSelect: {
    customBtnText: "مخصص",
    leftRadioText: {
      "0": "أمس",
      "1": "ما يقرب من 7 أيام",
      "2": "بالقرب من 30 يومًا",
      "3": "هذا الشهر"
    },
    DefaultRightSelectorText: ["يوما بعد يوم", "أسبوعي", "شهريا"]
  },
  DynamicForm: {
    newData: "محتوى جديد",
    clearData: "املأ كل المحتوى",
    delete: "يمسح",
    copy: "ينسخ",
    down: "بالتسلسل لأسفل",
    up: "اطلب إلى الأعلى",
    max: "يمكن إضافة معظم",
    item: "غرض",
    clearGroup: "مجموعة إزالة"
  },
  MisSearch: {
    noSearchResult: common.noSearchResult
  }
};